/*!
 * FrontAlign v1.0.9
 * (c) Eyruz Badalzada
 * Released under the MIT License
 * https://www.frontalign.dev
 */

import { useEffect } from "react";
import Components from "../js/core/Component.js";
import Form from "../js/components/Form.js";

/**
 * useNavbar
 * Initializes responsive navbar toggle interactions.
 */
export function useNavbar() {
  useEffect(() => {
    const dispose = Components.navbar();
    return () => dispose?.();
  }, []);
}

/**
 * useDrawer
 * Initializes drawer/offcanvas open-close behavior.
 */
export function useDrawer() {
  useEffect(() => {
    const dispose = Components.drawer();
    return () => dispose?.();
  }, []);
}

/**
 * useDropdown
 * Initializes dropdown click and hover interactions.
 */
export function useDropdown() {
  useEffect(() => {
    const dispose = Components.dropdown();
    return () => dispose?.();
  }, []);
}

/**
 * useCollapse
 * Initializes collapsible elements with.
 */
export function useCollapse() {
  useEffect(() => {
    const dispose = Components.collapse();
    return () => dispose?.();
  }, []);
}

/**
 * useAccordion
 * Initializes accessible accordion interactions.
 */
export function useAccordion() {
  useEffect(() => {
    const dispose = Components.accordion();
    return () => dispose?.();
  }, []);
}

/**
 * useAlert
 * Initializes dismissible alert components.
 */
export function useAlertDismiss() {
  useEffect(() => {
    const dispose = Components.alert();
    return () => dispose?.();
  }, []);
}

/**
 * useForm
 * Initializes form validation, file upload helpers.
 */
export function useForm() {
  useEffect(() => {
    const dispose = Form.init();
    return () => dispose?.();
  }, []);
}
